import type { ReactNode } from "react";

import { highlightRanges } from "@/lib/highlight";

interface HighlightProps {
  text: string;
  /** The search, as typed: each of its words is marked, ignoring case and accents. */
  query: string;
}

/**
 * Text with the search's matches marked in the theme's light blue (never the
 * browser's yellow), in the text's own casing and accents. The negative margin
 * offsets the mark's padding, so marking a match never shifts the text.
 */
export function Highlight({ text, query }: HighlightProps) {
  const ranges = highlightRanges(text, query);
  if (ranges.length === 0) {
    return text;
  }
  const parts: ReactNode[] = [];
  let at = 0;
  for (const [start, end] of ranges) {
    if (start > at) {
      parts.push(text.slice(at, start));
    }
    parts.push(
      <mark key={start} className="bg-highlight text-foreground -mx-0.5 rounded-sm px-0.5">
        {text.slice(start, end)}
      </mark>,
    );
    at = end;
  }
  if (at < text.length) {
    parts.push(text.slice(at));
  }
  return <>{parts}</>;
}
